// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"253e3a2a","453":"f16537cb","936":"38946d5b"}[chunkId] + ".chunk.js";
};